import { render, staticRenderFns } from "./DetailEvent.vue?vue&type=template&id=4ee5f561&scoped=true"
import script from "./DetailEvent.vue?vue&type=script&lang=js"
export * from "./DetailEvent.vue?vue&type=script&lang=js"
import style0 from "./DetailEvent.vue?vue&type=style&index=0&id=4ee5f561&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee5f561",
  null
  
)

export default component.exports